import React from 'react';
import { RichTextBlock } from 'prismic-reactjs';
import { defaultTheme } from '@styles/theme.styled';
import Text from '@components/text';
import Wrapper from '@components/wrapper.styled';
import {
  Container,
  Content,
  LinkButton,
  StyledSection,
  Heading,
  Actions,
} from './call-to-action.styled';

interface CallToActionProps {
  title?: string;
  subheading?: RichTextBlock[];
  buttonLabel?: string;
  link?: string;
  backgroundColor?: keyof typeof defaultTheme.backgroundColors;
}

const CallToAction = ({
  title,
  subheading = [],
  buttonLabel,
  link,
  backgroundColor = 'white',
}: CallToActionProps): JSX.Element => {
  const hasDescription: boolean = subheading?.length > 0 && subheading[0].text !== '';

  if (!hasDescription && !(buttonLabel && link)) {
    return <></>;
  }

  return (
    <StyledSection backgroundColor={backgroundColor || 'white'}>
      <Wrapper>
        <Container>
          <Content>
            <Heading>
              {title && (
                <Text
                  tag="h2"
                  fontSize="heading3"
                  type="title"
                  stringText={title}
                  fontColor="primary"
                  margin="none"
                />
              )}
              {subheading && (
                <Text type="subheading" richText={subheading} fontColor="white" margin="none" />
              )}
            </Heading>
            <Actions>
              {link && (
                <LinkButton type="button" url={link} title={buttonLabel || 'Request a Demo'} />
              )}
            </Actions>
          </Content>
        </Container>
      </Wrapper>
    </StyledSection>
  );
};

export default CallToAction;
